import http from '@/utils/http'

const publicApi = {
  // oss获取图片
  getStsAccessKeyInfo(params: any) {
    return http.post<any>('/common/sts/getStsAccessKeyInfo', params)
  },
  // 头部搜索框

  getSearchResources(data: any) {
    return http.get<any>('/business/homePage/findResourceName', { data })
  }

}
export default publicApi